import { render } from "./ImageEditor.vue?vue&type=template&id=3b0a9d5e&scoped=true&ts=true"
import script from "./ImageEditor.vue?vue&type=script&lang=ts"
export * from "./ImageEditor.vue?vue&type=script&lang=ts"

import "./ImageEditor.vue?vue&type=style&index=0&id=3b0a9d5e&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b0a9d5e"]])

export default __exports__